import { IBudgetAdjustment } from '../../interfaces/ibudget-adjustment';
import { Area } from '../area';
import { CostCode } from '../cost-code';
import { CostType } from '../cost-type';
import { ProjectType } from '../project-type';
import { Scenario } from '../scenario';

export class BudgetAdjustmentBase {
  BudgetAdjustmentId: number;
  ProjectTypeId: number;
  AreaId: number;
  ScenarioId: number | null;
  StartDate: Date;
  EndDate: Date;
  CostCodeId: number;
  CostTypeId: number;
  PercentAdjustment: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  CostCode?: CostCode;
  CostType?: CostType;
  ProjectType?: ProjectType;
  Scenario?: Scenario;

  constructor(item?: IBudgetAdjustment) {
    if (item) {

      this.BudgetAdjustmentId = item.BudgetAdjustmentId;
      this.ProjectTypeId = item.ProjectTypeId;
      this.AreaId = item.AreaId;
      this.ScenarioId = item.ScenarioId;
      this.StartDate = item.StartDate ? new Date(item.StartDate) : null;
      this.EndDate = item.EndDate ? new Date(item.EndDate) : null;
      this.CostCodeId = item.CostCodeId;
      this.CostTypeId = item.CostTypeId;
      this.PercentAdjustment = item.PercentAdjustment;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.CostCode = new CostCode(item.CostCode);
      this.CostType = new CostType(item.CostType);
      this.ProjectType = new ProjectType(item.ProjectType);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}